import { useDebugValue } from 'react';
import { CLAUSES_LIMIT } from '../../../constants';
import { useElseIfClausesWatch } from '../watchers/useElseIfClausesWatch';

export const useHasMaximumClauses = () => {
  const hasMaximumClauses = useElseIfClausesWatch().length >= CLAUSES_LIMIT;
  useDebugValue(hasMaximumClauses);
  return hasMaximumClauses;
};
